import { createAction } from '@reduxjs/toolkit';

export const UPDATE_CONVERSATION_NAME = 'UPDATE_CONVERSATION_NAME';
export const updateConversationNameAction = createAction(
  UPDATE_CONVERSATION_NAME,
  (messageSessionId, newSessionName) => ({
    payload: { messageSessionId, newSessionName }
  })
);